export default __webpack_public_path__ + "static/media/saturn.e4a7f811.svg";